export default "__VITE_ASSET__DBP0fMCM__"